module.exports = __webpack_public_path__ + "media/images/writer/community/pc-title-70d7ff3a7a9c9132df40abd119ec39ec.png";